import React from 'react';

import { adlessCommand} from '.';
import { AccountsRequest, AccountsResponse } from './gen/admin';
import { KPIsRequest, KPIsResponse, PoolAnalyticsRequest, PoolAnalyticsResponse, ServiceAnalyticsRequest, ServiceAnalyticsResponse } from './gen/analytics';

export default {
    accounts: (req: AccountsRequest) => adlessCommand<AccountsResponse>("/v1/admin/accounts", req),
}